import React from "react";
import PropTypes from "prop-types";

const ExportSheetIcon = ({
  width,
  height,
  color,
  strokeWidth,
  className,
  ...props
}) => (
  <svg
    width={width || 18}
    height={height || 18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M2.52778 5.15V1.55C2.52778 1.33783 2.62143 1.13434 2.78813 0.984315C2.95483 0.834285 3.18092 0.75 3.41667 0.75H15.8611C16.0969 0.75 16.323 0.834285 16.4897 0.984315C16.6564 1.13434 16.75 1.33783 16.75 1.55V15.95C16.75 16.1622 16.6564 16.3657 16.4897 16.5157C16.323 16.6657 16.0969 16.75 15.8611 16.75H3.41667C3.18092 16.75 2.95483 16.6657 2.78813 16.5157C2.62143 16.3657 2.52778 16.1622 2.52778 15.95V12.35M12.75 5.15H14.0833M11.4167 8.35H14.0833M11.4167 11.55H14.0833M3.41667 7.55L4.75 8.75M4.75 8.75L6.08333 9.95M4.75 8.75L6.08333 7.55M4.75 8.75L3.41667 9.95M0.75 5.15H8.75V12.35H0.75V5.15Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

ExportSheetIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

ExportSheetIcon.defaultProps = {
  width: undefined,
  height: undefined,
  color: "currentColor",
  strokeWidth: 1.5,
  className: "",
};

export default ExportSheetIcon;
